export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      userFullName: filter.userFullName[0] ? filter.userFullName : '*',
      resource: filter.resource[0] ? filter.resource : '*',
      action: filter.action[0] ? filter.action : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
